import * as React from "react";
const SvgTrigger3 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "_7-5-3-1", x1: -632.4, y1: 1119.99, x2: 351.15, y2: 163.24, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, stopColor: "#003e6b" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.34, stopColor: "#2680c0" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.67, stopColor: "#64b1e8" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#b4dffe" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "_7-5-3-1-2", x1: -632.3, y1: 1120.09, x2: 351.25, y2: 163.35, xlinkHref: "#_7-5-3-1" }), /* @__PURE__ */ React.createElement("linearGradient", { id: "_7-5-3-1-3", x1: 54.9, y1: 451.26, x2: 456.32, y2: 60.79, xlinkHref: "#_7-5-3-1" })), /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 512, height: 512, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "dark" }, /* @__PURE__ */ React.createElement("rect", { x: 39.26, y: 39.26, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#64b1e8",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 183.75, y: 39.26, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 328.25, y: 39.26, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 39.26, y: 183.75, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 183.75, y: 183.75, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 39.26, y: 328.25, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#64b1e8",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 183.75, y: 328.25, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 328.25, y: 328.25, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#b4dffe",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("rect", { x: 328.25, y: 183.75, width: 144.5, height: 144.5, rx: 30.96, style: {
  fill: "#64b1e8",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("path", { d: "M265.69,93.37l42.95,86.48a10.3,10.3,0,0,0,7.78,5.63L412,199.13a10.32,10.32,0,0,1,5.77,17.59l-69,67.57a10.3,10.3,0,0,0-2.94,9.15l16.56,95.12a10.33,10.33,0,0,1-15,10.92l-85.57-44.71a10.31,10.31,0,0,0-9.61,0l-85.36,45.15a10.32,10.32,0,0,1-15-10.85L168,293.88a10.31,10.31,0,0,0-3-9.13L95.7,217.53a10.33,10.33,0,0,1,5.68-17.63l95.52-14.12a10.31,10.31,0,0,0,7.75-5.67l42.52-86.69A10.33,10.33,0,0,1,265.69,93.37Z", style: {
  fill: "#003e6b",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 20
} }), /* @__PURE__ */ React.createElement("polygon", { points: "255.64 255.95 255.69 256 256 256 256 255.59 255.64 255.95", style: {
  fill: "url(#_7-5-3-1)"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "256 256.31 256 256 255.69 256 256 256.31", style: {
  fill: "url(#_7-5-3-1-2)"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "255.59 256 255.69 256 255.64 255.95 255.59 256", style: {
  fill: "url(#_7-5-3-1-3)"
} }))));
export default SvgTrigger3;
